export default "__VITE_ASSET__f2f5360f__"